<template>
  <div class="profile">
    <ProfileTabNav
      :tabs="tabs"
      :selected="selected"
      @selected="setSelectedTab"
    >
      <Tab :is-selected="selected === 'Dados pessoais'">
        <AvatarForm />
        <UserForm />
        <PasswordForm />
        <DoctorPropertyForm v-if="isDoctor" />
        <!-- <wire-card-account v-if="isDoctor" /> -->
        <div class="profile__card">
          <button
            class="button1"
            @click="showConfirmationDeleteAccountModal()"
          >
            Deletar conta
          </button>
        </div>
      </Tab>

      <!-- <Tab :is-selected="selected === 'Qualificações'" /> -->

      <!-- <Tab :is-selected="selected === 'Financeiro'">
        <CreditCard @pushNewCreditCard="pushNewCreditCard" v-if="!isDoctor" />
        <CreditCardList ref="cardList" v-if="!isDoctor" />
        <BankAccountForm v-if="isDoctor" />
      </Tab> -->

      <Tab :is-selected="selected === 'Financeiro'">
        <CreditCard @pushNewCreditCard="pushNewCreditCard" v-if="!isDoctor" />
        <CreditCardList ref="cardList" v-if="!isDoctor" />
        <DoctorWallet v-if="isDoctor" />
      </Tab>

      <Tab :is-selected="selected === 'Endereço'">
        <Address />
      </Tab>
    </ProfileTabNav>

    <BModal
      id="createCreditCard"
      ref="createCreditCard"
      hide-footer
      centered
      title="Cadastrar um novo cartão"
    >
      <div>
        <CreditCard @pushNewCreditCard="pushNewCreditCard" />
      </div>
    </BModal>

    <BModal
      id="confirmationModal"
      ref="confirmationModal"
      hide-footer
      hide-header
      centered
    >
      <div class="p-5">
        <h4 class="title-2 text-color-secondary text-center mb-4">
          {{ `Tem certeza de que ${alertMessage}` }}
        </h4>
        <BButton class="button2 mb-2" block @click="deleteAccount()">
          Confirmar
        </BButton>

        <BButton
          class="button2 mb-2"
          block
          @click="hideConfirmationDeleteAccountModal()"
        >
          Cancelar
        </BButton>
      </div>
    </BModal>

    <BModal
      id="accountDeleted"
      ref="accountDeleted"
      hide-footer
      hide-header
      centered
    >
      <div class="p-5">
        <h4 class="title-2 text-color-secondary text-center mb-4">
          Sua conta foi deletada
        </h4>
      </div>
    </BModal>
  </div>
</template>

<script>
import Address from "./../components/Address";
import CreditCard from "./../components/CreditCard";
import CreditCardList from "./../components/CreditCardList";
import ProfileTabNav from "../components/ProfileTabNav";
import Tab from "../components/Tab";
import DoctorPropertyForm from "./../components/DoctorPropertyForm";
import UserForm from "./../components/UserForm";
import AvatarForm from "../components/AvatarForm.vue";
import DoctorWallet from '../components/DoctorWallet';
import PasswordForm from '../components/PasswordForm.vue';

export default {
  name: "Profile",
  components: {
    Address,
    CreditCard,
    CreditCardList,
    ProfileTabNav,
    Tab,
    DoctorPropertyForm,
    UserForm,
    AvatarForm,
    DoctorWallet,
    PasswordForm,
  },
  data() {
    return {
      deletedAccountIsAppear: false,
      alertMessage: 'quer excluir sua conta?',
      selected: "Dados pessoais",
      tabs: [
        { title: "Dados pessoais", icon: "user-icon" },
        // { title: 'Qualificações', icon: 'layout-square-icon' },
        { title: "Financeiro", icon: "dollar-sign-icon" },
        { title: "Endereço", icon: "map-pin-icon" }
      ]
    };
  },
  async mounted() {
    if (this.$route.params.selected) {
      this.setSelectedTab(this.$route.params.selected)
    }
  },
  methods: {
    setSelectedTab(tab) { this.selected = tab },

    pushNewCreditCard(credit_card) {
      this.$refs.cardList.addCreditCard(credit_card);
    },

    showAccountDeletedModal() {
      this.deletedAccountIsAppear = true
      this.$bvModal.show("accountDeleted")
    },

    deleteAccount() {
      this.$store.dispatch('user/deleteUser')
      this.showAccountDeletedModal();
      if (this.deletedAccountIsAppear == true) {
        setTimeout(() => this.$router.push('/login'), 3500);
      }
    },

    hideConfirmationDeleteAccountModal() {
      this.$bvModal.hide("confirmationModal")
    },

    showConfirmationDeleteAccountModal() {
      this.$bvModal.show("confirmationModal")
    },
  },

  computed: {
    isDoctor() { return this.$store.state.user.userRole == "doctor" }
  },
};
</script>
